import { Observable, Subscription } from "rxjs";
import { Injectable } from "@angular/core";
import { EventsService } from "./EventsService";


@Injectable()
export class ObservaleQueue2 {
	public q: Subscription[] = [];
	
	constructor(
		public eventsService: EventsService,
	) {
		const me = this;

		me.eventsService
			.on('filter-apply', () => {
				me.start();
			})
			.on('compoment-destroy', () => {
				me.reset();
			})
	}

	start() {
		this.reset();
	}

	push<T extends object>(o$: Observable<any>): Observable<T> {
		const me = this;

		return new Observable(observer => {
			const q$ = o$.subscribe(
				(d) => {
					observer.next(d);
				},
				err => {
					observer.error(err);
				},
				() => {
					const index = me.q.findIndex(q => Object.is(q, q$));
					
					if (index === -1) {
						console.error(me.q, o$);
						
						throw new Error('ObservaleQueue2 complete error: couldt find subscription of o$');
					}
					
					me.q.splice(index, 1);
					
					observer.complete();
				}
			)
			
			me.q.push(q$);
		});
	}


	reset() {
		for (let o2$ of this.q) {
			o2$.unsubscribe();
		}

		this.q = [];
	}

	ngOnDestroy() {
		this.eventsService.off('filter-apply');
	}
}
